export default __webpack_public_path__ + "static/media/gordon.bcd79a41.svg";